import * as React from "react";
const SvgFastForward = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, viewBox: "2 2 20 20", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z", fill: "#3D6EDF" }));
export { SvgFastForward as ReactComponent };
